import React, { useEffect, useState } from "react";
import "./AddDriver.scss";
import { Field, ErrorMessage, Formik, Form } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import {
  createDriverByAdmin,
  validateDriverEmail,
  validateDriverPhone,
  uploadDocuments
} from "../../../../../utils/apis/services/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../../../header/Header";
import Button from "../../../../../components/button/Button";
// import OtpInput from "react-otp-input";
import FormikPhoneInput from "../FormikPhoneInput";
// import Modal from "react-modal";
import translate from "../../../../../utils/locale/language";
import Loader from "react-loader-spinner";
// import firebase from "../../../../../firebase";

const AddDriver = () => {
  // const [verifiedNumber, setVerifiedNumber] = useState("");
  // const [otp, setOtp] = useState(false);
  // const [otpvalue, setOTPvalue] = useState("");
  // const [otpvalid, setOtpValid] = useState(false);
  // const [loader, setLoader] = useState(false);
  const [loader1, setLoader1] = useState(false);
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    type: "",
    name: "",
    email: "",
    number: "",
    address: "",
    gender: "",
    martial_status: "",
    mode_of_partner: "",
    social_insurence_number: "",
    driver_document: "",
    driver_licsences_front: "",
    driver_licsences_back: "",
  });

  const [driverDoc, setDriverDoc] = useState(null);
  const [driverDocPreview, setDriverDocPreview] = useState("");
  const [driverLicenseFront, setDriverLicenseFront] = useState(null);
  const [driverLicenseBack, setDriverLicenseBack] = useState(null);
  const [driverLicenseFrontPreview, setDriverLicenseFrontPreview] = useState("");
  const [driverLicenseBackPreview, setDriverLicenseBackPreview] = useState("");
  const [uploadingField, setUploadingField] = useState("");

  const isValidImageFile = (file) => {
    if (!file) return false;
    const t = (file.type || "").toLowerCase();
    return t === "image/jpeg" || t === "image/jpg" || t === "image/png";
  };

  const uploadOnSelect = async (file, apiKey, apiFileNameKey, fieldName, setFieldError, setFieldValue) => {
    if (!file) return;
    setUploadingField(fieldName);
    const fd = new FormData();
    fd.append(apiKey, file);
    fd.append(apiFileNameKey, file?.name || "");
    const up = await uploadDocuments(fd);
    setUploadingField("");
    if (!(up?.data?.ResponseMessage === "Documents are uploaded." || up?.data?.ResponseCode === 200)) {
      toast.warning(up?.data?.ResponseMessage || "Upload failed");
      setFieldError(fieldName, up?.data?.ResponseMessage || "Upload failed");
      setFieldValue(fieldName, "");
    }
  };

  const ref = React.createRef();
  const history = useHistory();

  const getValidationSchema = (s) => {
    const step1 = {
      name: Yup.string().min(2, "Mininum 2 characters").max(30, "Maximum 30 characters").required("required"),
      email: Yup.string()
        .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i, "Invalid email address")
        .required("required"),
      number: Yup.string().required(" "),
      address: Yup.string()
        .required("required")
        .min(8, "Mininum 8 characters")
        .matches(/^[ A-Za-z0-9_./,-]*$/, "Specail characters are not allowed"),
    };
    const step2 = {
      gender: Yup.string().required("required"),
      martial_status: Yup.string().required("required"),
      mode_of_partner: Yup.string().required("required"),
      social_insurence_number: Yup.string().required("required"),
      driver_document: Yup.mixed().required("required"),
      driver_licsences_front: Yup.mixed().required("required"),
      driver_licsences_back: Yup.mixed().required("required"),
    };
    return Yup.object(s === 1 ? step1 : { ...step1, ...step2 });
  };

  const onSubmit = async (values, { setFieldError }) => {
    if (step === 1) {
      const emailToCheck = (values.email || "").toLowerCase().trim();
      const phoneToCheck = (values.number || "").toString();
      const phoneNumber = phoneToCheck ? phoneToCheck.substring(3).trim() : "";

      if (emailToCheck) {
        const res = await validateDriverEmail(emailToCheck);
        const ok = res?.data?.ResponseData?.success === true;
        if (!ok) {
          setFieldError("email", res?.data?.ResponseData?.response || res?.data?.ResponseMessage || "Email already exists");
          return;
        }
      }

      if (phoneNumber) {
        const res = await validateDriverPhone(phoneNumber);
        const ok = res?.data?.ResponseData?.success === true;
        if (!ok) {
          setFieldError("number", res?.data?.ResponseData?.response || res?.data?.ResponseMessage || "Phone number already exists");
          return;
        }
      }

      setFormData((prev) => ({ ...prev, ...values }));
      setStep(2);
      return;
    }
      let datas = {
        current_address: values.address ? values.address : "",
        email: values.email ? values.email.toLowerCase() : "",
        full_name: values.name ? values.name : "",
        phone_number: values.number ? values.number.substring(3) : "",
        gender: values.gender || "",
        martial_status: values.martial_status || "",
        mode_of_partner: values.mode_of_partner || "",
        social_insurence_number: values.social_insurence_number || "",
        driver_document: driverDoc || null,
        driver_image: driverDocPreview || null,
        driver_licsences: [driverLicenseFront, driverLicenseBack],
        create_by_admin: true
      };
      setLoader1(true);

      const emailCheck = await validateDriverEmail(datas.email);
      const emailSuccess = emailCheck?.data?.ResponseData?.success === true;
      if (!emailSuccess) {
        setLoader1(false);
        toast.warning(emailCheck?.data?.ResponseData?.response || emailCheck?.data?.ResponseMessage || "Email already exists");
        return;
      }

      const phoneCheck = await validateDriverPhone(datas.phone_number);
      const phoneSuccess = phoneCheck?.data?.ResponseData?.success === true;
      if (!phoneSuccess) {
        setLoader1(false);
        toast.warning(phoneCheck?.data?.ResponseData?.response || phoneCheck?.data?.ResponseMessage || "Phone number already exists");
        return;
      }

      if (!driverDoc || !isValidImageFile(driverDoc)) {
        setLoader1(false);
        setFieldError("driver_document", "Driver document is required (JPG/PNG/JPEG)");
        return;
      }
      if (!driverLicenseFront || !isValidImageFile(driverLicenseFront)) {
        setLoader1(false);
        setFieldError("driver_licsences_front", "License front is required (JPG/PNG/JPEG)");
        return;
      }
      if (!driverLicenseBack || !isValidImageFile(driverLicenseBack)) {
        setLoader1(false);
        setFieldError("driver_licsences_back", "License back is required (JPG/PNG/JPEG)");
        return;
      }

      let result = await createDriverByAdmin(datas);
      const created =
        result?.data?.ResponseData?.response ||
        result?.data?.ResponseData ||
        result?.data?.response ||
        result?.data;
      const driverId = created?.id || created?.driver_id || created?.driver_meta_id;
      if (driverId) {
      //   setLoader1(false);
      //   // history.push({
      //   //   pathname: "/drivers/driverdocuments",
      //   //   state: { driverId: driverId },
      //   // });
      //   history.push("/drivers");
      // } else {
      //   setLoader1(false);
        const fd = new FormData();
        fd.append("passport_photo", driverDoc);
        fd.append("passport_photo_filename", driverDoc?.name || "");
        fd.append("licsence_front", driverLicenseFront);
        fd.append("licsence_front_filename", driverLicenseFront?.name || "");
        fd.append("licsence_back", driverLicenseBack);
        fd.append("licsence_back_filename", driverLicenseBack?.name || "");
        fd.append("driver_id", driverId);

        const up = await uploadDocuments(fd);
        if (up?.data?.ResponseMessage === "Documents are uploaded." || up?.data?.ResponseCode === 200) {
          setLoader1(false);
          history.push("/drivers");
        } else {
          setLoader1(false);
          toast.warning(up?.data?.ResponseMessage || "Upload failed");
        }
      } else {
        setLoader1(false);
        toast.warning(result?.data?.ResponseMessage || result?.data?.response || "Failed");
      }
  };

  // Phone number validation disabled

  // const validateNumber = (number) => {
  //   setLoader(true);
  //   getCaptcha();
  //   firebase
  //     .auth()
  //     .signInWithPhoneNumber(number, appVerifier)
  //     .then(function (confirmationResult) {
  //       // SMS sent. Prompt user to type the code from the message, then sign the
  //       // user in with confirmationResult.confirm(code).
  //       setLoader(false);
  //       setOtp(true);
  //       setVerifiedNumber(number);
  //       window.confirmationResult = confirmationResult;
  //     })
  //     .catch(function (error) {
  //       // Error; SMS not sent
  //       // ...
  //       setLoader(false);
  //       toast.dismiss();
  //       toast.warning(error.message);
  //       window.sessionStorage.setItem("phno", "");
  //       // window.recaptchaVerifier.clear()
  //       window.setTimeout(() => {
  //         window.location.reload();
  //       }, 5000);
  //       appVerifier.reset();
  //     });
  // };

  // const handleOTP = (otp) => setOTPvalue(otp);
  // const confirmOTP = () => {
  //   window.confirmationResult
  //     .confirm(otpvalue)
  //     .then(function (result) {
  //       // User signed in successfully.
  //       setOtp(false);
  //       toast.dismiss();
  //       toast.success("Phone Number validated successfully");
  //       setOtpValid(true);
  //       // ...
  //     })
  //     .catch(function (error) {
  //       // User couldn't sign in (bad verification code?)
  //       // ...
  //       toast.dismiss();
  //       if (error.message === "INVALID_CODE") {
  //         toast.warn("INVALID_CODE");
  //       } else {
  //         toast.warn("Session Expired or Entered Invalid Code");
  //         setOtp(false);
  //         window.sessionStorage.setItem("phno", "");
  //         window.recaptchaVerifier.render().then(function (widgetId) {
  //           window.recaptchaVerifier.reset(widgetId);
  //         });
  //         window.setTimeout(() => {
  //           window.location.reload();
  //         }, 3500);
  //       }
  //     });
  // };

  return (
    <>
      {/* <div id="recaptcha-container" ref={captchaRef}></div> */}
      {/* <Modal isOpen={otp} className="otpcard" overlayClassName="EditOverlay">
        <div>
          <i
            className="fa fa-close"
            aria-hidden="true"
            onClick={() => {
              setOtp(false);
              window.sessionStorage.setItem("phno", "");
              window.location.reload();
            }}
            style={{
              cursor: "pointer",
              float: "right",
              fontSize: 20,
              marginRight: "-20px",
            }}
          ></i>
        </div>
        <div style={{ textAlign: "center" }}>
          <p style={{ fontWeight: "500", fontSize: 17, height: 5 }}>
            {translate("pleaseenterotp")}
          </p>
          <p style={{ color: "#00000061", fontSize: 14 }}>
            {translate("codesent")}xxxxxx{verifiedNumber.substring(9, 13)}
          </p>
        </div>
        <OtpInput
          containerStyle={{ justifyContent: "center" }}
          value={otpvalue}
          onChange={handleOTP}
          numInputs={6}
          separator={<span>-</span>}
          inputStyle="inputStyle"
          isInputNum
          shouldAutoFocus={true}
        />
        <p
          style={{
            color: "#00000061",
            fontSize: 14,
            justifyContent: "center",
            display: "flex",
          }}
        >
          {translate("didntgetcode")}
          <p
            style={{ color: "#03A8EE", margin: 0 }}
            onClick={() => {
              window.location.reload();
            }}
          >
            {translate("resendit")}
          </p>
        </p>
        <div style={{ display: "flex", placeContent: "center", marginTop: 15 }}>
          <button
            className="button"
            style={{ width: 80, height: 30, border: "none", outline: "none" }}
            onClick={() => {
              setOTPvalue("");
            }}
          >
            {translate("clear")}
          </button>
          <button
            className="button"
            style={{
              width: 80,
              height: 30,
              marginLeft: 10,
              border: "none",
              outline: "none",
            }}
            disabled={otpvalue.length < 6}
            onClick={() => confirmOTP()}
          >
            {translate("verify")}
          </button>
        </div>
      </Modal> */}
      <div className="add-new-driver">
        <Header title="Drivers" />
      </div>
      <div>
        <span class="color-grey">{translate("addNewDriver")}</span>
        <span class="step2of3">{translate("step")} {step === 1 ? "2" : "3"} Of 3</span>
      </div>
      <div className="driverdetails">
        {loader1 ? (
          <div style={{ padding: "43%", textAlign: "center" }}>
            {" "}
            <Loader color="#03A8EE" />{" "}
          </div>
        ) : (
          <Formik
            initialValues={formData}
            enableReinitialize={true}
            validationSchema={getValidationSchema(step)}
            onSubmit={onSubmit}
          >
            {({ errors, touched, values, setFieldValue, handleChange, handleBlur, setFieldError }) => {
              return (
                <Form className="form">
                  <div className="next-back-button">
                    <button
                      className="back"
                      type="button"
                      onClick={() => {
                        if (step === 1) {
                          window.sessionStorage.setItem("phno", "");
                          history.push("/drivers/becomeadriver");
                        } else {
                          setFormData(values);
                          setStep(step - 1);
                        }
                      }}
                    >
                      {translate("back")}
                    </button>
                    {step === 1 ? (
                      <button type="submit" className="next">
                        {translate("next")}
                      </button>
                    ) : (
                      <button type="submit" className="next">
                        {translate("save")}
                      </button>
                    )}
                  </div>
                  <p className="details-label">
                    {step === 1 ? translate("personalDetails") : step === 2 ? (translate("professionalDetails") || "Professional Details") : "Documents"}
                  </p>
                  <p className="details-title">
                    {translate("personalDetailsInfo")}
                  </p>
                  {step === 2 && (
                    <>
                      <div className={touched.gender && errors.gender ? "input-field field-line" : "input-field "}>
                        <label htmlFor="gender" className="input-label">
                          {translate("gender")}
                        </label>
                        <Field
                          as="select"
                          id="gender"
                          name="gender"
                          className={touched.gender && errors.gender ? "input line" : "input "}
                          onChange={(e) => {
                            const val = e?.target?.value || "";
                            setFieldValue("gender", val);
                            setFormData((prev) => ({ ...prev, gender: val }));
                          }}
                        >
                          <option value="">{translate("select")}</option>
                          <option value="male">{translate("male")}</option>
                          <option value="female">{translate("female")}</option>
                        </Field>
                        <ErrorMessage name="gender">{(err) => <div className="err">{err}</div>}</ErrorMessage>
                      </div>

                      <div className={touched.martial_status && errors.martial_status ? "input-field field-line" : "input-field "}>
                        <label htmlFor="martial_status" className="input-label">
                          {translate("martialStatus")}
                        </label>
                        <Field
                          as="select"
                          id="martial_status"
                          name="martial_status"
                          className={touched.martial_status && errors.martial_status ? "input line" : "input "}
                          onChange={(e) => {
                            const val = e?.target?.value || "";
                            setFieldValue("martial_status", val);
                            setFormData((prev) => ({ ...prev, martial_status: val }));
                          }}
                        >
                          <option value="">{translate("select")}</option>
                          <option value="married">{translate("married")}</option>
                          <option value="unmarried">{translate("unmarried")}</option>
                        </Field>
                        <ErrorMessage name="martial_status">{(err) => <div className="err">{err}</div>}</ErrorMessage>
                      </div>

                      <div className={touched.mode_of_partner && errors.mode_of_partner ? "input-field field-line" : "input-field "}>
                        <label htmlFor="mode_of_partner" className="input-label">
                          {translate("modeOfPartner")}
                        </label>
                        <Field
                          as="select"
                          id="mode_of_partner"
                          name="mode_of_partner"
                          className={touched.mode_of_partner && errors.mode_of_partner ? "input line" : "input "}
                          onChange={(e) => {
                            const val = e?.target?.value || "";
                            setFieldValue("mode_of_partner", val);
                            setFormData((prev) => ({ ...prev, mode_of_partner: val }));
                          }}
                        >
                          <option value="">{translate("select")}</option>
                          <option value="bike">{translate("bike")}</option>
                          <option value="car">{translate("car")}</option>
                          <option value="truck">{translate("truck")}</option>
                        </Field>
                        <ErrorMessage name="mode_of_partner">{(err) => <div className="err">{err}</div>}</ErrorMessage>
                      </div>
                      <div className={touched.social_insurence_number && errors.social_insurence_number ? "input-field field-line" : "input-field "}>
                        <label htmlFor="social_insurence_number" className="input-label">
                          {translate("socialInsuranceNumber")}
                        </label>
                        <Field
                          autoComplete="off"
                          className={touched.social_insurence_number && errors.social_insurence_number ? "input line" : "input "}
                          type="text"
                          id="social_insurence_number"
                          name="social_insurence_number"
                          placeholder="Social Insurance Number"
                          onChange={(e) => {
                            handleChange(e);
                            setFormData((prev) => ({ ...prev, social_insurence_number: e?.target?.value || "" }));
                          }}
                        />
                        <ErrorMessage name="social_insurence_number">{(err) => <div className="err">{err}</div>}</ErrorMessage>
                      </div>

                      <div className="input-field">
                        <label className="input-label">{translate("driverDocumentUpload")}</label>
                        {!driverDocPreview && (
                        <label
                          htmlFor="driver_document_input"
                          style={{ width: 120, height: 120, border: "1px dashed #03A8EE", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", fontSize: 40, color: "#03A8EE", background: "#f7fcff" }}
                        >
                          +
                        </label>
                        )}
                        <input
                          id="driver_document_input"
                          type="file"
                          accept="image/png,image/jpeg,image/jpg"
                          style={{ display: "none" }}
                          onChange={async (e) => {
                            const f = e?.target?.files?.[0] || null;
                            if (f && !isValidImageFile(f)) {
                              setDriverDoc(null);
                              setDriverDocPreview("");
                              setFieldError("driver_document", "Only JPG/PNG/JPEG allowed");
                              setFieldValue("driver_document", "");
                              return;
                            }
                            setDriverDoc(f);
                            setFieldError("driver_document", "");
                            setFieldValue("driver_document", f || "");
                            setDriverDocPreview(f ? URL.createObjectURL(f) : "");
                            await uploadOnSelect(f, "passport_photo", "passport_photo_filename", "driver_document", setFieldError, setFieldValue);
                          }}
                        />
                        <ErrorMessage name="driver_document">{(err) => <div className="err">{err}</div>}</ErrorMessage>
                        {uploadingField === "driver_document" ? <div className="err">Uploading...</div> : null}
                        {driverDocPreview ? <img alt="" src={driverDocPreview} style={{ width: 120, height: 120, objectFit: "cover", marginTop: 10, borderRadius: 8 }} /> : null}
                      </div>

                      <div className="input-field">
                        <label className="input-label">{translate("driverLicensesUploadFront")}</label>
                        {!driverLicenseFrontPreview && (
                        <label
                          htmlFor="driver_lic_front_input"
                          style={{ width: 120, height: 120, border: "1px dashed #03A8EE", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", fontSize: 40, color: "#03A8EE", background: "#f7fcff" }}
                        >
                          +
                        </label>
                        )}
                        <input
                          id="driver_lic_front_input"
                          type="file"
                          accept="image/png,image/jpeg,image/jpg"
                          style={{ display: "none" }}
                          onChange={async (e) => {
                            const f = e?.target?.files?.[0] || null;
                            if (f && !isValidImageFile(f)) {
                              setDriverLicenseFront(null);
                              setDriverLicenseFrontPreview("");
                              setFieldError("driver_licsences_front", "Only JPG/PNG/JPEG allowed");
                              setFieldValue("driver_licsences_front", "");
                              return;
                            }
                            setDriverLicenseFront(f);
                            setFieldError("driver_licsences_front", "");
                            setFieldValue("driver_licsences_front", f || "");
                            setDriverLicenseFrontPreview(f ? URL.createObjectURL(f) : "");
                            await uploadOnSelect(f, "licsence_front", "licsence_front_filename", "driver_licsences_front", setFieldError, setFieldValue);
                          }}
                        />
                        <ErrorMessage name="driver_licsences_front">{(err) => <div className="err">{err}</div>}</ErrorMessage>
                        {uploadingField === "driver_licsences_front" ? <div className="err">Uploading...</div> : null}
                        {driverLicenseFrontPreview ? <img alt="" src={driverLicenseFrontPreview} style={{ width: 120, height: 120, objectFit: "cover", marginTop: 10, borderRadius: 8 }} /> : null}
                      </div>

                      <div className="input-field">
                        <label className="input-label">{translate("driverLicensesUploadBack")}</label>
                        {!driverLicenseBackPreview && (
                        <label
                          htmlFor="driver_lic_back_input"
                          style={{ width: 120, height: 120, border: "1px dashed #03A8EE", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", fontSize: 40, color: "#03A8EE", background: "#f7fcff" }}
                        >
                          +
                        </label>
                        )}
                        <input
                          id="driver_lic_back_input"
                          type="file"
                          accept="image/png,image/jpeg,image/jpg"
                          style={{ display: "none" }}
                          onChange={async (e) => {
                            const f = e?.target?.files?.[0] || null;
                            if (f && !isValidImageFile(f)) {
                              setDriverLicenseBack(null);
                              setDriverLicenseBackPreview("");
                              setFieldError("driver_licsences_back", "Only JPG/PNG/JPEG allowed");
                              setFieldValue("driver_licsences_back", "");
                              return;
                            }
                            setDriverLicenseBack(f);
                            setFieldError("driver_licsences_back", "");
                            setFieldValue("driver_licsences_back", f || "");
                            setDriverLicenseBackPreview(f ? URL.createObjectURL(f) : "");
                            await uploadOnSelect(f, "licsence_back", "licsence_back_filename", "driver_licsences_back", setFieldError, setFieldValue);
                          }}
                        />
                        <ErrorMessage name="driver_licsences_back">{(err) => <div className="err">{err}</div>}</ErrorMessage>
                        {uploadingField === "driver_licsences_back" ? <div className="err">Uploading...</div> : null}
                        {driverLicenseBackPreview ? <img alt="" src={driverLicenseBackPreview} style={{ width: 120, height: 120, objectFit: "cover", marginTop: 10, borderRadius: 8 }} /> : null}
                      </div>
                    </>
                  )}

                  {step === 1 && (
                  <>
                  <div
                    className={
                      touched.type && errors.type
                        ? "input-field field-line"
                        : "input-field "
                    }
                  >
                    <label htmlFor="type" className="input-label">
                      {translate("typeOfPartner")}
                      <span className="eg">
                        {translate("typeOfPartneHints")}
                      </span>
                    </label>
                    {/* <Field as="select" name="type" className={touched.type && errors.type ? "input line" : "input "}>
                  <option value="choose"  >Choose Type</option>
                  <option value="Shop">Shop</option>
                  <option value="Restaurant">Restaurant</option>
                  <option value="Driver">Driver</option>
                </Field> */}
                    <Field
                      autoComplete="off"
                      className="input"
                      type="text"
                      id="type"
                      name="type"
                      value="Driver"
                      disabled
                    />
                    {/* <ErrorMessage name='type' >
                  {
                    (err) => <div className='err'>{err}</div>
                  }
                </ErrorMessage> */}
                  </div>

                  <div
                    className={
                      touched.name && errors.name
                        ? "input-field field-line"
                        : "input-field "
                    }
                  >
                    <label htmlFor="name" className="input-label">
                      {translate("fullName")}
                      <span className="eg">{translate("fullNameHints")}</span>
                    </label>
                    <Field
                      autoComplete="off"
                      className={
                        touched.name && errors.name ? "input line" : "input "
                      }
                      type="text"
                      id="name"
                      name="name"
                      placeholder={translate("fullNamePlaceholder")}
                    />
                    <ErrorMessage name="name">
                      {(err) => <div className="err">{err}</div>}
                    </ErrorMessage>
                  </div>
                  <div
                    className={
                      touched.email && errors.email
                        ? "input-field field-line"
                        : "input-field "
                    }
                  >
                    <label htmlFor="email" className="input-label">
                      {translate("emailAddress")}
                      <span className="eg">
                        {translate("emailAddressHints")}
                      </span>
                    </label>
                    <Field
                      autoComplete="off"
                      className={
                        touched.email && errors.email ? "input line" : "input "
                      }
                      type="text"
                      id="email"
                      name="email"
                      placeholder={translate("emailPlaceholder")}
                      onBlur={async (e) => {
                        handleBlur(e);
                        const email = (values.email || "").toLowerCase().trim();
                        if (!email) return;
                        const res = await validateDriverEmail(email);
                        const ok = res?.data?.ResponseData?.success === true;
                        if (!ok) {
                          setFieldError("email", res?.data?.ResponseData?.response || res?.data?.ResponseMessage || "Email already exists");
                        }
                      }}
                    />
                    <ErrorMessage name="email">
                      {(err) => <div className="err">{err}</div>}
                    </ErrorMessage>
                  </div>

                  <div
                    className={
                      touched.number && errors.number
                        ? "input-field field-line"
                        : "input-field "
                    }
                  >
                    <label htmlFor="email" className="input-label">
                      {translate("phoneNumber")}
                      <span className="eg">
                        {translate("phoneNumberHints")}
                      </span>
                    </label>
                    <div style={{ display: "flex" }}>
                      <FormikPhoneInput
                        ref={ref}
                        className={
                          touched.number && errors.number
                            ? "input line"
                            : "input "
                        }
                        id="number"
                        name="number"
                        value={values.number}
                        formik={{ handleChange, handleBlur }}
                        onChange={(e) => {
                          setFieldValue("number", e);
                          window.sessionStorage.setItem("phno", e);
                        }}
                        onBlur={async (e) => {
                          handleBlur(e);
                          const phone_number = (values.number || "").trim();
                          if (!phone_number) return;
                          const res = await validateDriverPhone(phone_number);
                          const ok = res?.data?.ResponseData?.success === true;
                          if (!ok) {
                            setFieldError("number", res?.data?.ResponseData?.response || res?.data?.ResponseMessage || "Phone number already exists");
                          }
                        }}
                      />
                      {/* {loader ? (
                        <Loader
                          width="100px"
                          color="#03A8EE"
                          height="50px"
                          type="Bars"
                        ></Loader>
                      ) : (
                        <Button
                          style={{
                            marginLeft: 18,
                            fontSize: 14,
                            height: 30,
                            width: 75,
                            marginTop: 19,
                          }}
                          title="Validate"
                          onClick={() => validate()}
                        ></Button>
                      )} */}
                      <ErrorMessage name="number">
                        {(err) => <div className="err">{err}</div>}
                      </ErrorMessage>
                    </div>
                  </div>
                  <div
                    className={
                      touched.address && errors.address
                        ? "input-field field-line"
                        : "input-field "
                    }
                  >
                    <label htmlFor="email" className="input-label">
                      {translate("currentAddress")}
                      <span className="eg">
                        {translate("currentAddressHints")}
                      </span>
                    </label>
                    <Field
                      autoComplete="off"
                      className={
                        touched.address && errors.address
                          ? "input line"
                          : "input "
                      }
                      type="text"
                      id="address"
                      name="address"
                      placeholder={translate("currentAddressPlaceholder")}
                    />
                    <ErrorMessage name="address">
                      {(err) => <div className="err">{err}</div>}
                    </ErrorMessage>
                  </div>
                  </>
                  )}
                </Form>
              );
            }}
          </Formik>
        )}
      </div>
    </>
  );
};

export default AddDriver;

